import React, {useEffect} from "react"
import PropTypes from "prop-types"
import {Skeleton, Tabs} from "antd"
import BookSettingBase from "./component/BookSettingBase"
import BookSettingLock from "./component/BookSettingLock"
import BookSettingRefund from "./component/BookSettingRefund"
import BookSettingRelation from "./component/BookSettingRelation"
import {useClubTableBookSettingContext} from "./store/useClubTableBookSettingContext"

const BookSettingsLayout = ({tableIds, isBatch}) => {

    const {getTableReservationProperty, isLoading} = useClubTableBookSettingContext()


    useEffect(() => {
        if (isBatch) {
            return
        }
        getTableReservationProperty(tableIds[0])
    }, [])

    if (isLoading) {
        return <Skeleton></Skeleton>
    }

    return (<div>
        <Tabs
            tabPosition={"left"}
        >
            <Tabs.TabPane tab={"基础设置"} key={"1"}>
                <BookSettingBase/>
            </Tabs.TabPane>
            <Tabs.TabPane tab={"锁房设置"} key={"2"}>
                <BookSettingLock/>
            </Tabs.TabPane>
            <Tabs.TabPane tab={"退款设置"} key={"3"}>
                <BookSettingRefund/>
            </Tabs.TabPane>
            {!isBatch && <Tabs.TabPane tab={"关联套餐"} key={"4"}>
                <BookSettingRelation/>
            </Tabs.TabPane>}
        </Tabs>
    </div>)
}

BookSettingsLayout.prototype = {
    tableId: PropTypes.string.isRequired
}

export default BookSettingsLayout



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/BookSettingsLayout.js